import MiddleNameField from './MiddleNameField';

export default MiddleNameField;
